export const enumPermisosPinesVus = Object.freeze({
    operarPinesVus: 53,
    administrarPinesVus: 63  
  });